import React from 'react';
import { TranslationOptions } from 'i18next';
import { withTranslation, WithTranslationProps } from 'react-i18next';
import { isI18nextDebugEnabled } from '../../i18n';

type Props = WithTranslationProps & {
  children?: string;
  options?: TranslationOptions;
};

export class Locale extends React.PureComponent<Props> {
  render() {
    const { i18n, children, options } = this.props;

    if (!children || !i18n) {
      return null;
    }

    const res = i18n.t(children, { ...options, interpolation: { escapeValue: false } });

    if (isI18nextDebugEnabled()) {
      const hasTranslation = i18n.exists(children, options);

      if (hasTranslation) {
        return <span style={{ border: '1px ForestGreen dashed' }}>{res}</span>;
      } else {
        return <span style={{ backgroundColor: 'pink' }}>{res}</span>;
      }
    }

    return res;
  }
}

export default withTranslation()(Locale);
